import styled from "@emotion/styled";
import React from "react";
import LogoIMg from "../../assets/gadget.svg";
const Logo = () => {
  return (
    <div>
      <h1>
        <Div>
          <img src={LogoIMg} alt="" />
          GADGETING
        </Div>
      </h1>
      <p className="logo-desc">Nayi Technology, Nayi Udaan</p>
    </div>
  );
};

export default Logo;

const Div = styled.div`
  font-family: "Cabin", sans-serif;
  font-weight: 700;
  font-size: 35px;
  display: flex;
  img {
    width: 50px;
    height: auto;
  }
`;
